import React from 'react';

/**
 * Consistent page wrapper used across all admin pages.
 * Provides a page header with title + action buttons, and a content area.
 */
const PageLayout = ({ title, actions, children }) => {
  return (
    <div style={{ padding: '28px 32px', maxWidth: '1200px', margin: '0 auto', width: '100%' }}>
      {(title || actions) && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '24px',
          flexWrap: 'wrap',
          gap: '12px',
        }}>
          {title && (
            <h1 style={{
              fontSize: '22px',
              fontWeight: 700,
              color: 'var(--text-primary, #1a1a2e)',
              margin: 0,
              letterSpacing: '-0.3px',
            }}>
              {title}
            </h1>
          )}
          {actions && (
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
              {actions}
            </div>
          )}
        </div>
      )}
      {children}
    </div>
  );
};

export default PageLayout;
